export default "__VITE_ASSET__BXmh4oQS__"